/* eslint-disable */
export default defineNuxtPlugin(() => {
    return;
    if (process.server) { return; }

    // 1) Required globals
    //    Tip: pull the license from runtimeConfig so you don't hardcode it
    const config = useRuntimeConfig();
    const license = Number(config.public?.liveChatKey);

    // Avoid double-init on client nav
    if ((window as any).__lc?.__nuxtLiveChatLoaded) {
        return

        ;
    }(window as any).__lc = (window as any).__lc || {}
    ;(window as any).__lc.license = license
    ;(window as any).__lc.integration_name = 'manual_channels'
    ;(window as any).__lc.product_name = 'livechat'
    ;(window as any).__lc.__nuxtLiveChatLoaded = true

    // 2) Bootstrapper (your IIFE, lightly formatted)
    ;(function (n, t, c) {
        function i (n: any[]) { return (e as any)._h ? (e as any)._h.apply(null, n) : (e as any)._q.push(n); }
        const e: any = {
            _q: [],
            _h: null,
            _v: '2.0',
            on () { i(['on', c.call(arguments)]); },
            once () { i(['once', c.call(arguments)]); },
            off () { i(['off', c.call(arguments)]); },
            get () { if (!e._h) { throw new Error('[LiveChatWidget] You can\'t use getters before load.'); } return i(['get', c.call(arguments)]); },
            call () { i(['call', c.call(arguments)]); },
            init () {
                const s = t.createElement('script');
                s.async = true;
                s.type = 'text/javascript';
                s.src = 'https://cdn.livechatinc.com/tracking.js';
                t.head.appendChild(s);
            }
        };
        if (!(n as any).__lc.asyncInit) {
            e.init()
            ;
        }(n as any).LiveChatWidget = (n as any).LiveChatWidget || e;
    })(window, document, [].slice);
});
